var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoSubscribers = function SvgNoSubscribers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 310,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m41.008 47.474-4.06-3.117H6.24c-2.706 0-4.941-2.236-4.941-4.942V21.708c0-2.707 2.235-4.942 4.941-4.942h32.827c2.706 0 4.941 2.235 4.941 4.942v24.296c-.059 1.53-1.765 2.412-3 1.47Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.654 33.179-1.589-3.53v-.764a5.122 5.122 0 0 0-5.118-5.119 5.122 5.122 0 0 0-5.118 5.119v.764l-1.588 3.53c-.647 1.53.412 3.236 2.118 3.236h1.764a2.824 2.824 0 0 0 2.824 2.823 2.788 2.788 0 0 0 2.824-2.823h1.765c1.647 0 2.765-1.706 2.118-3.236Z",
    fill: "#C3DDFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.536 36.415h-9.119c-1.647 0-2.764-1.706-2.117-3.236l1.588-3.53v-.764a5.122 5.122 0 0 1 5.118-5.119 5.122 5.122 0 0 1 5.118 5.119v.764l1.588 3.53c.648 1.53-.47 3.236-2.176 3.236Zm-7.354 0a2.824 2.824 0 0 0 5.648 0m191.899 272.61h-31.767a4.615 4.615 0 0 1-4.589-5.294l4.706-35.239c.294-2.294 2.294-4.059 4.589-4.059h22.355c2.353 0 4.294 1.706 4.588 4.059l4.706 35.239a4.615 4.615 0 0 1-4.588 5.294Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.49 305.672a4.624 4.624 0 0 0 4.471 3.412h31.767a4.622 4.622 0 0 0 4.471-3.412H181.49Z",
    fill: "#1D4ED8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.786 244.608s18.649-7.059 24.002-22.943c0 0-21.002-.824-24.002 22.943Zm-4.118 2.412s-7.824-14.236-25.943-9.765c0 0 7.353 12.53 25.943 9.765Z",
    fill: "#C3DDFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.845 264.492s-.412-30.12-14.413-42.827",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.256 256.962s-.176-16.825 13.472-27.355",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M203.786 244.608s18.649-7.059 24.002-22.943c0 0-21.002-.824-24.002 22.943Zm-4.118 2.412s-7.824-14.236-25.943-9.765c0 0 7.353 12.53 25.943 9.765Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.668 247.02s-8.001-7.236-18.414-7.53m16.884 1.412s3.059-23.473-17.766-24.767c.059 0 .118 9.648 17.766 24.767ZM1 309h250",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M162.9 172.896h-26.825a3.476 3.476 0 0 1 3.471-3.47h23.413v3.47h-.059Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.9 172.896h-26.825a3.476 3.476 0 0 1 3.471-3.47h23.413v3.47h-.059Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.547 172.896h50.475c1.647 0 3.177-1.353 3.412-3l4.412-28.649c.235-1.647-.882-3-2.529-3h-50.475c-1.647 0-3.177 1.353-3.412 3l-4.412 28.649c-.236 1.647.882 3 2.529 3Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.273 158.244c1.693-1.567 1.973-4.017.626-5.47-1.347-1.454-3.81-1.362-5.502.205-1.693 1.568-1.973 4.017-.626 5.471 1.347 1.454 3.81 1.362 5.502-.206Z",
    fill: "#C3DDFD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M159.547 172.896h50.475c1.647 0 3.177-1.353 3.412-3l4.412-28.649c.235-1.647-.882-3-2.529-3h-50.475c-1.647 0-3.177 1.353-3.412 3l-4.412 28.649c-.236 1.647.882 3 2.529 3Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M189.853 158.222c1.693-1.568 1.973-4.017.626-5.471-1.347-1.454-3.81-1.362-5.502.206-1.693 1.567-1.973 4.016-.626 5.47 1.347 1.454 3.81 1.362 5.502-.205Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.61 178.06h115.363v-5.177H110.61v5.177Z",
    fill: "#1D4ED8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.872 178.06h115.362v-5.177H108.872v5.177Zm27.203.013v77.477m83.242-77.477v38.062m0 27.12v15.648m-83.242 2.354v47.768m-23.237-130.952v130.952",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m236.965 50.945 5.53 53.711-11.883 14.648-43.357 4.471c-1.353.117-2.588-.883-2.706-2.236l-6.706-64.476c-.118-1.353.882-2.588 2.235-2.706l54.181-5.588a2.413 2.413 0 0 1 2.706 2.176Z",
    fill: "#1D4ED8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m236.965 50.945 5.53 53.711-11.883 14.648-44.945 4.647c-1.353.118-2.589-.882-2.706-2.235l-6.648-64.535c-.118-1.353.824-2.588 2.236-2.706l55.769-5.706c1.294-.177 2.53.823 2.647 2.176Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m242.495 104.714-10.824 1.118c-1.353.118-2.353 1.353-2.236 2.706l1.118 10.825 11.942-14.649Z",
    fill: "#fff",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m176.901 63.417 60.711-6.236",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m212.728 73.359-24.766 2.53c-.471.058-.824-.295-.883-.706l-.235-2.177c-.059-.47.294-.824.706-.882l24.766-2.53c.471-.059.824.294.883.706l.235 2.177c.059.47-.294.882-.706.882Z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m187.903 83.183 42.121-4.353m-41.592 9.648 42.121-4.353m-41.592 9.588 29.826-3.059",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m195.02 108.479-2.883.295c-.705.058-1.235-.648-.941-1.354l1.177-2.647 1.176-2.647c.294-.647 1.236-.765 1.648-.177l1.706 2.354 1.706 2.353c.411.588.058 1.412-.648 1.529l-2.941.294Zm10.354-9 2.883-.294c.706-.06 1.235.647.941 1.353l-1.176 2.647-1.177 2.647c-.294.647-1.235.765-1.647.177l-1.706-2.354-1.706-2.353c-.412-.588-.059-1.412.647-1.53l2.941-.293Zm-28.708-55.24-42.886-4.942c-1.412-.176-2.353-1.412-2.235-2.823l2.765-24.002c.176-1.412 1.411-2.354 2.823-2.236l42.886 4.942c1.412.176 2.353 1.412 2.236 2.823l-2.765 24.002c-.177 1.412-1.412 2.412-2.824 2.236Z",
    fill: "#C3DDFD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m175.371 44.062-42.768-4.941c-1.412-.177-2.412-1.471-2.294-2.883l2.941-25.237c.177-1.412 1.471-2.412 2.883-2.294l42.768 4.941c1.412.177 2.412 1.47 2.294 2.883l-2.941 25.237c-.177 1.47-1.471 2.47-2.883 2.294Z",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m134.31 9.236 19.472 15.53a3.948 3.948 0 0 0 4.294.471l22.531-10.706",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M136.78 35.885a2.294 2.294 0 1 0 0-4.588 2.294 2.294 0 0 0 0 4.588Z",
    fill: "#fff",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m131.191 5.824-2.882-3.647m9.883 2.588L138.663 1m-9.942 11.53-4.059-.47m70.594 7.118s9.531-5.295 12.884 3.177c3.353 8.53-10.354 12.412-8.119 6.235 2.236-6.177 15.943-1.117 14.119 15.59m-61.653 108.891c-2.764 2-7.059.294-8.647-2.765-1.589-3.059-.883-6.824.706-9.883 1.588-3.059 4-5.589 6.059-8.295 2.118-2.706 3.941-5.824 4.177-9.236.117-2-.471-4.294-2.118-5.412-1.647-1.176-4.471-.588-5 1.412-.648 2.353 2.47 4.294 4.823 3.589 2.354-.706 3.824-2.883 5.118-4.942 4.648-7.295 8.942-14.766 16.414-18.355",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M101.072 298.613a172.43 172.43 0 0 1-10.118-5.707l.353-6.294-14.472.294c-.118 2.588-.294 7.059-.294 7.059l-1.412 11.06c-.294 2.118 1.412 4 3.53 4h25.825c1.941 0 3.412-1.941 2.824-3.765-.765-2.353-2.824-4.883-6.236-6.647Zm-38.121 4.176c-4.765-3.353-8.765-8.294-8.765-8.294l1.059-4.648-15.649-1.588-1.765 6.942-3.647 8.353c-1.118 2.589.765 5.53 3.647 5.53h26.355c1.295 0 2.236-1.177 1.883-2.412-.294-1.118-1.118-2.471-3.118-3.883ZM43.95 138.247c-.765-.059-1.236-.295-1.236-.295S19.83 104.656 27.478 95.008c6.883-8.707 17.06-17.296 22.354-21.473a29.046 29.046 0 0 1 16.06-6.236c8.413-.588 20.473-1 24.767.706 6.824 2.765 22.414 20.12 25.12 20.885 2.706.823 6.471-3.766 34.062-12.649 0 0 2.882-3.765 3.529-5.47.647-1.707 1.177-2.707 1.589-2.942.411-.235 1.411.647 1.294 4.294 0 0 4.765-3 7-4.353 2.236-1.353 4.471 4.06 4.295 5.942-.177 1.882-3 5-5.412 6.883-1.883 1.47-8.825 3.588-8.825 3.588s-24.413 22.002-36.355 22.002c-9.531 0-16.237-5.412-16.237-5.412s-3.118 4.53-3.824 9.118c-.647 4.589.588 10.942 1.059 15.649.53 4.706.765 7.177.765 7.177s-2.471 6-20.355 6c-16.825 0-24.237-5.471-24.237-5.471s1.176-5.059 2.059-8.236c.882-3.177 2.118-7.236 1.824-10.765-.295-3.53-2.295-12.237-2.589-13.413-.294-1.177-1.059-4.53-1.059-4.53s-6.648 4.294-8.589 5.883c-1.941 1.588-1.941 1.765-.882 6.059 1 4.353 4.47 17.06 4.706 18.06.294 1 1.706 5.824 1.647 6.295-.059.471-.353 2.883-3.294 4.353-2.942 1.471-4 1.295-4 1.295Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M89.012 67.653c-5.177-1.177-15.59-.765-23.178-.236a28.444 28.444 0 0 0-15.06 5.471c0-5.236 4.53-10.589 7.588-14.472 7.471-9.53 5.648-19.119 5.648-19.119s14.472-4.647 22.825 0c7.766 4.295 3.177 13.296 2.177 28.356Zm2.118 222.018s-6.06 2.235-14.472 1.529l.177-4.118s7.177 1.177 14.295-.235v2.824Zm-51.887-.236s6.236 4.001 14.943 5.06l1.176-4.648s-11.589-.353-15.825-1.471l-.294 1.059Zm65.3 19.59H78.717c-2.177 0-3.824-1.882-3.53-4l1.177-9.06h6a3.41 3.41 0 0 1 2.824 1.471l1 1.353a4.943 4.943 0 0 0 4.06 2.118h14.236c1.471 1.353 2.471 2.883 2.941 4.353.53 1.883-.941 3.765-2.882 3.765Zm-40.416 0H37.772c-2.824 0-4.765-2.941-3.647-5.53l3.294-7.589h2.647c.706 0 1.295.295 1.765.706.47.471.706 1.059.706 1.765a2.486 2.486 0 0 0 2.471 2.471H60.48a38.093 38.093 0 0 0 2.412 1.883c2 1.411 2.824 2.764 3.118 3.823.353 1.295-.589 2.471-1.883 2.471ZM101.602 97.42s3.647 6.294 10.53 8.471c0 0-8.471-1.824-11.766-5.118 0 0 .941-2.412 1.236-3.353Z",
    fill: "#1D4ED8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M102.66 182.191c-2.236 25.002-3.118 34.356-3.118 34.356l-.647 68.123s-12.236 6.295-29.473.294l-.53 2.883c-16.942 6.353-41.238-4.236-41.238-4.236l18.472-62.77s.118-18.648 0-46.356c-.059-12.766 2.235-23.179 4.589-30.062 0 0 2.706-8.471 5.647-11.648 1.118 1.059 3.412 2.295 4.589 2.765 4.941 2.001 12.589 4.06 24.472 3.059 11.53-.941 13.472-5.765 13.472-5.765s6 24.355 3.765 49.357Z",
    fill: "#C3DDFD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m72.07 286.023 7-62.946-10.824 59.064-.53 2.882s3.648 1.118 4.354 1Zm8.589-221.077H70.48c-5.647 0-9.648-5.47-7.942-10.824 0-.059.06-.118.06-.176 2.352-7.001 2.352-12.943 2.352-12.943l15.65 1.942v22.001h.059Z",
    fill: "#1D4ED8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M58.95 73.594c6.178 4.354 6.178 12.707 3.06 16.943-2.765 3.824-17.531 10.942-17.884 13.824-.294 2.883 7 27.826 7 27.826s.118.412-.058 1.059",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M43.95 138.246c-.765-.058-1.236-.294-1.236-.294S19.83 104.655 27.478 95.008c6.883-8.707 17.06-17.296 22.354-21.473a29.046 29.046 0 0 1 16.06-6.236c8.413-.588 20.473-1 24.767.706 6.824 2.765 22.414 20.12 25.12 20.885 2.706.823 6.471-3.766 34.062-12.649 0 0 2.882-3.765 3.529-5.47.647-1.707 1.177-2.707 1.589-2.942.411-.235 1.412.647 1.294 4.294 0 0 4.765-3 7-4.353 2.236-1.353 4.471 4.06 4.295 5.942-.177 1.882-3 5-5.412 6.883-1.883 1.47-8.825 3.588-8.825 3.588s-24.413 22.002-36.355 22.002c-9.531 0-16.237-5.412-16.237-5.412",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m93.306 74.477 2.118 5.647c1.765 1.647 7.236 5.471 7.236 11.413 0 4.235-2.059 9.118-3.883 12.589a18.735 18.735 0 0 0-2 10.707l1.942 18.001s-2 4.824-14.12 5.765c-12.47 1.001-20.53-1.058-25.707-3.059-1.177-.47-3.648-1.706-4.824-2.765l2.941-10.765a26.07 26.07 0 0 0 .236-12.942l-2.942-12.472m44.416 36.238s6.294 24.355 3.941 49.357c-2.353 25.002-3.236 34.356-3.236 34.356l-.705 68.064s-12.825 6.295-30.944.236",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54.068 132.775c-3.059 3.118-5.883 11.648-5.883 11.648-2.47 6.942-4.883 17.296-4.824 30.062.118 27.708 0 46.356 0 46.356l-19.354 62.77s25.473 10.589 43.239 4.236L79.6 220.312c.411-2.177.647-4.412.706-6.589l1.764-45.474s2.589-3.177 3.824-6.177c1.236-2.941 0-12.942 0-12.942m-9.059 137.776c-.118 2.588-.294 7.059-.294 7.059l-1.412 11.06c-.294 2.118 1.412 4 3.53 4h25.825c1.941 0 3.412-1.941 2.824-3.765-.765-2.353-2.883-4.883-6.236-6.589a172.738 172.738 0 0 1-10.118-5.706l.353-6.295M44.244 105.538s-1.177-4.412-3.53-5.883",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M43.95 162.66s6.706 3.471 11.942-3.706c4.412-6 4.765-11.942 4.765-11.942",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.775 44.062a6.824 6.824 0 1 0 0-13.648 6.824 6.824 0 0 0 0 13.648Z",
    fill: "#1D4ED8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m85.247 61.71-.47 7.06s3.529 4.471 1.47 7.883c-1.882 3.118-10.53 2-13.236-4.53-.471-1.117-.53-2.412-.294-3.647l1.529-7.353c.059.058 6-2.177 11 .588Zm-25.002 80.478c-.294 2.177-2.706 8.118-6.177 4.942-3.47-3.177-3.588-1.883-6.53-2.942-2.764-.941-3.47-5.353-3.53-5.942 1.06.118 2.648-.058 4.354-1.353 1.941-1.47 2.588-2.764 2.765-3.647 0 0 1.824-.059 3.353-.235 1.47-.236 5.471-.177 4.765 1.412-.647 1.529-4.294.823-3.588 1.47.706.706 4.883 4.177 4.588 6.295Z",
    fill: "#fff",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M43.95 138.246v-.058m101.714-60.535s5.118 1.06 5.236 8.707M55.185 289.847l-1.059 4.648s4 4.941 8.766 8.294c2 1.412 2.824 2.765 3.118 3.824.294 1.236-.647 2.412-1.883 2.412H37.772c-2.824 0-4.765-2.941-3.647-5.53l3.647-8.353 1.765-6.942",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M60.48 300.907H45.008a2.486 2.486 0 0 1-2.47-2.471 2.486 2.486 0 0 0-2.471-2.471h-2.648m66.947 4.942H90.13a4.865 4.865 0 0 1-4.06-2.118l-1-1.353a3.41 3.41 0 0 0-2.823-1.471h-6m-50.946-16.707s25.179 9.295 42.71 4.353m.529-3s14.001 5.177 30.179 0M82.07 168.19s-.353-4.118-2.942-5.706",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6 45.71v7.353c0 6.589-5.353 11.883-11.883 11.883-5.059 0-9.353-3.176-11.06-7.588-1.94-.236-3.411-1.824-3.411-3.824 0-1.706 1.117-3.118 2.588-3.648V45.71a9.089 9.089 0 0 1 9.118-9.118h5.53c5 0 9.119 4.06 9.119 9.118Z",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M74.128 63.005a11.609 11.609 0 0 1-4.53-5.647c-1.94-.236-3.412-1.824-3.412-3.824 0-1.706 1.118-3.118 2.589-3.648V45.71a9.089 9.089 0 0 1 9.118-9.118h5.53a9.09 9.09 0 0 1 9.119 9.118v7.354c0 6.589-5.354 11.883-11.884 11.883 0 0-.647.177-2.706-.294-2.059-.47-3.47-1.412-3.47-1.412l-.354-.235Z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M74.128 63.005a11.609 11.609 0 0 1-4.53-5.647c-1.94-.236-3.412-1.824-3.412-3.824 0-1.706 1.118-3.118 2.589-3.648V45.71a9.089 9.089 0 0 1 9.118-9.118h5.53a9.09 9.09 0 0 1 9.119 9.118v7.354c0 6.589-5.354 11.883-11.884 11.883",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M90.483 49.71H73.717a8.687 8.687 0 0 1-8.707-8.707 8.687 8.687 0 0 1 8.707-8.706h9.824c6.707 0 12.178 5.47 12.178 12.177a5.247 5.247 0 0 1-5.236 5.236Z",
    fill: "#1D4ED8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M69.07 54.18v-7.53h7.53c0 4.119-3.354 7.53-7.53 7.53Z",
    fill: "#1D4ED8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M115.72 89.007c-.235.059-.882 1.177-.235 3.295",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M55.186 147.894s-4.824-.647-8.707 1.706l1.647-5.235s2.177.588 2.706.529c.53 0 3.353 2.236 4.354 3Zm30.708 14.178s-1.824 5.648-1.824 6.942c0 1.294-3.53 38.003-3.53 38.003l1.589-38.944c.059 0 2.588-3.06 3.765-6.001Z",
    fill: "#1D4ED8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m33.83 286.847 17.884-63.064c.294-1 .295-2.059-.058-3-.177-.412-.236-1 .117-1.706s.53-1.53.47-2.295c-.234-7.941-1.176-44.356.942-55.063",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M68.54 59.24c-1 0-1.765-.824-1.765-1.765 0-1 .823-1.765 1.765-1.765 1 0 1.765.824 1.765 1.765a1.77 1.77 0 0 1-1.765 1.765Z",
    fill: "#C3DDFD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M80.835 64.946s1.588 1.883 4.06 2.118l.176-3c.058.059-1.706.765-4.236.882ZM62.95 89.007s-4.647 10.59-6.117 18.296c0 0-2.824-10.59-2.295-10.942.47-.353 7.59-4.824 8.413-7.354Z",
    fill: "#1D4ED8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m83.01 78.36-2.47 2.882c-1.824 2.118-5.118 2.118-6.942 0-1.53-1.765-3.059-4.118-3.647-6.765-1.412-6.119 2.059-7.413 2.059-7.413M83.012 78.36l3.706 2.823c1.53 1.177 3.765.176 3.941-1.765.177-1.824 0-4.118-.94-6.53-1.942-4.883-4.825-5.824-4.825-5.824",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M84.011 82.595a.706.706 0 1 0 0-1.412.706.706 0 0 0 0 1.412Z",
    fill: "#1D4ED8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M82.482 78.889a2.95 2.95 0 0 0-.647 2.294l.647 4.706m5-37.885.647 4.647a2.057 2.057 0 0 1-2.06 2.353m-45.355 79.948s7.353 1.412 9.471-6.118m92.066-50.004s6.001 1.294 5.471 10.118",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M82.423 51.475a.779.779 0 0 1-.764-.765v-.883c0-.411.353-.764.764-.764.412 0 .765.353.765.764v.883a.779.779 0 0 1-.765.765Zm7.707 0a.779.779 0 0 1-.765-.765v-.883c0-.411.353-.764.764-.764.412 0 .765.353.765.764v.883a.779.779 0 0 1-.765.765Z",
    fill: "#1D4ED8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M79.188 57.122s.882 2 3.823 1.589",
    stroke: "#1D4ED8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgNoSubscribers;